// IE and Firefox interact badly with ExtJS XTemplates, which use the with statement as: `with (values)`,
// which, in IE/FF, resolves as Array.prototype.values instead of the actual template parameter
// when the XTemplate's value is an array. Modern browsers correctly use the owned-properties of values,
// but IE/FF do not.
//
delete Array.prototype.values;
